import { render } from "./CommonLoader.vue?vue&type=template&id=95471602&scoped=true&ts=true"
import script from "./CommonLoader.vue?vue&type=script&lang=ts"
export * from "./CommonLoader.vue?vue&type=script&lang=ts"

import "./CommonLoader.vue?vue&type=style&index=0&id=95471602&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95471602"]])

export default __exports__